// extracted by mini-css-extract-plugin
export var formContainer = "_m3-0";
export var message = "_m3-1";